// extracted by mini-css-extract-plugin
export default {"container-header-modal":"style_container-header-modal__363sL","container-close-icon":"style_container-close-icon__ItAT-"};